// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__7i625","filesListContainer":"PosDisputesFiles_filesListContainer__3cQSx","filesButton":"PosDisputesFiles_filesButton__3yz2V"};